import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";

import { TypographyDirective } from "../typography/typography.directive";

@Component({
  selector: "bit-header",
  templateUrl: "./header.component.html",
  imports: [RouterLink, TypographyDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  /**
   * The title of the page
   */
  readonly title = input.required<string>();

  /**
   * Icon to show before the title
   */
  readonly icon = input<string>();

  /**
   * Optional route for a back link shown before the title
   */
  readonly backRouterLink = input<string | readonly string[]>();
}
